const riskManagement = {
  riskManagement: 'Risk Mngmt.',
}
export default riskManagement
